import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/farmaforum-2025-qbd-group")({
  head: () => buildRouteHead("/es/farmaforum-2025-qbd-group", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/eventos", replace: true });
  },
});
